export const IMAGE_MAX_SIZE = 2048;
export const SUBMISSION_SOURCE = 'submission';
